import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

const posts = [
  {
    slug: "find-sponsors",
    title: "How to find sponsors for your SaaS using X (Twitter)",
    description:
      "A practical playbook for using public X threads as a top-of-funnel discovery channel.",
    date: "2026-04-15",
    to: "/blog/find-sponsors",
  },
  {
    slug: "ai-replies-without-bans",
    title: "How to use AI replies on X without getting banned",
    description:
      "The five rules every X-marketing team needs — and why human-in-the-loop is non-negotiable.",
    date: "2026-04-02",
    to: "/blog/find-sponsors",
  },
  {
    slug: "intent-vs-keyword",
    title: "Intent scoring vs keyword matching, explained",
    description:
      "Why intent-scored leads convert 4× better than keyword-matched ones — with the math.",
    date: "2026-03-20",
    to: "/blog/find-sponsors",
  },
];

export default function Blog() {
  return (
    <MarketingPage
      seo={{
        title: "Blog — Playbooks for B2B social outreach on X (Twitter) & LinkedIn",
        description:
          "Practical playbooks on X (Twitter), LinkedIn and Reddit lead generation, AI reply workflows, intent scoring, and the future of B2B social outreach.",
        path: "/blog",
        keywords:
          "Collavue blog, X lead generation playbook, Twitter lead generation playbook, LinkedIn lead generation playbook, AI social outreach blog, B2B marketing blog",
      }}
    >
      <PageHero
        eyebrow="Blog"
        title="Playbooks for AI-assisted"
        italicWord="GTM."
        description="Practical writing on X (Twitter), LinkedIn and Reddit lead generation, AI reply workflows, and the future of human-in-the-loop outreach."
      />

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-5xl mx-auto px-6 py-20 grid gap-5">
          {posts.map((p) => (
            <Link
              key={p.slug}
              to={p.to}
              className="group rounded-xl border border-[#e3dccb] p-6 bg-[#faf6ee]/40 hover:border-[#2d5bff] transition-colors flex items-start justify-between gap-6"
            >
              <div>
                <span className="text-xs uppercase tracking-wider text-[#5a6478]">{p.date}</span>
                <h2 className="font-display text-2xl text-[#0a1736] font-semibold mt-2">{p.title}</h2>
                <p className="text-[#5a6478] mt-2 leading-relaxed">{p.description}</p>
              </div>
              <ArrowUpRight className="w-5 h-5 text-[#2d5bff] mt-1 shrink-0 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          ))}
        </div>
      </section>
    </MarketingPage>
  );
}
